export const blockIconsCommunicationLiveHelp = (
	<span className='material-symbols-outlined'>live_help</span>
);
